import authToken from '@/functions/authToken'
import axios from 'axios'
import store from '@/store'

/**
 * Log user in and get auth token
 * @param {Object} data Data
 * @param {String} data.username User name
 * @param {String} data.password User password
 */
function login (data) {
  return axios
    .post('rest-auth/get-token/', {
      username: data.username,
      password: data.password
    })
    .then(response => {
      authToken.set(response.data.token)
      return response
    })
}

/**
 * Log user out
 */
function logout () {
  return axios
    .post('rest-auth/logout/')
    .catch(() => {
      // Silently ignore errors and pretend to logout
    })
    .then(() => {
      authToken.remove()
      store.commit('user/reset')
    })
}

/**
 * Change password
 * @param {String} data.oldPassword Old password
 * @param {String} data.newPassword New password
 */
function password (data) {
  return axios
    .post('rest-auth/change-password/', {
      old_password: data.oldPassword,
      new_password: data.newPassword
    })
}

export default {
  login,
  logout,
  password
}
